"use strict";var t=require("./tokeniseString.cjs");exports.constantCase=function(e){return t.tokeniseString(e).map((function(t){return t.toUpperCase()})).join("_")};
//# sourceMappingURL=constantCase.cjs.map
